import { useEffect } from "react";
import { H6, Title } from "../../components/Typography/Typography";
import { CenterContainer } from "../../layout/publicPageLayout";

export const AutoCloseBrowserTab = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      // Navigate to the same tab first; some browsers require this before closing
      window.open("", "_self");
      window.close();
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  return (
    <CenterContainer>
      <Title>Closing this tab...</Title>
      <H6>If it stays open, you can close it safely.</H6>
    </CenterContainer>
  );
};
